import { type SagaIterator } from "@redux-saga/core";
import { call, put, takeEvery } from "redux-saga/effects";
import {
  getDraftOrder,
  deleteDraftOrder,
} from "../../services/draftOrder/draftOrder.api";
import {
  type OrderDetailsList,
  DraftOrderPayload,
} from "../../types/draftOrder";
import { draftOrderActions } from "./slice";
import { PayloadAction } from "@reduxjs/toolkit";
import { withLoader } from "../loader/saga";

// Worker Sagas
export function* onGetDraftOrder(
  action: PayloadAction<DraftOrderPayload>
): SagaIterator {
  try {
    const draftOrders: OrderDetailsList = yield* withLoader(function* () {
      return yield call(getDraftOrder, action.payload);
    });
    yield put(draftOrderActions.fetchAllSucceeded(draftOrders));
  } catch (e: unknown) {
    if (e instanceof Error) {
      yield put(draftOrderActions.fetchAllFailure(e.message.toString()));
    }
  }
}

function* deleteDraftOrderSaga(action: PayloadAction<number>) {
  try {
    const orderId = action.payload;

    const response = yield* withLoader(function* () {
      return yield call(deleteDraftOrder, orderId);
    });

    yield put(draftOrderActions.deleteOrderSuccess(orderId));
  } catch (error: any) {
    yield put(draftOrderActions.deleteOrderFailure(error.message));
  }
}

// Watcher Saga
function* draftOrderWatcherSaga(): SagaIterator {
  yield takeEvery(draftOrderActions.fetchAll.type, onGetDraftOrder);
}

function* deleteOrderWatcherSaga(): SagaIterator {
  yield takeEvery(
    draftOrderActions.deleteOrderRequest.type,
    deleteDraftOrderSaga
  );
}

export { draftOrderWatcherSaga, deleteOrderWatcherSaga };
